// Rutas raíz de la aplicación
import { Routes } from '@angular/router';
import { authGuard } from './features/guards/auth.guard';
import { pendingInvoicesGuard } from './features/guards/pending-invoices.guard';
import { terminalFlowGuard } from './features/guards/terminal-flow.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/cotizador',
    pathMatch: 'full',
  },
  {
    path: 'cotizador',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layouts/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent,
      ),
    loadChildren: () =>
      import('./features/quoter/quoter.routes').then((m) => m.quoterRoutes),
  },
  {
    path: 'error',
    canActivate: [terminalFlowGuard],
    loadComponent: () =>
      import('./pages/error/error.component').then((m) => m.ErrorComponent),
  },
  {
    //facturas_pendientes
    path: 'cotizador/facturas_pendientes',
    canActivate: [pendingInvoicesGuard],
    loadComponent: () =>
      import('./features/pending-invoices/pages/pending-invoices/pending-invoices.component').then(
        (m) => m.PendingInvoicesComponent,
      ),
  },
  {
    // Fines de flujo: pantallas terminales alcanzables desde cualquier punto de la app.
    path: 'fin-de-flujo/conexion',
    canActivate: [terminalFlowGuard],
    loadComponent: () =>
      import('./pages/terminal-flows/connection-error/connection-error.component').then(
        (m) => m.ConnectionErrorComponent,
      ),
  },
  {
    path: 'fin-de-flujo/error-500',
    canActivate: [terminalFlowGuard],
    loadComponent: () =>
      import('./pages/terminal-flows/server-error/server-error.component').then(
        (m) => m.ServerErrorComponent,
      ),
  },
  {
    path: 'fin-de-flujo/error-404',
    canActivate: [terminalFlowGuard],
    loadComponent: () =>
      import('./pages/terminal-flows/not-found-error/not-found-error.component').then(
        (m) => m.NotFoundErrorComponent,
      ),
  },
  {
    path: 'fin-de-flujo/placa-fasecolda',
    canActivate: [terminalFlowGuard],
    loadComponent: () =>
      import('./pages/terminal-flows/fasecolda-not-found/fasecolda-not-found.component').then(
        (m) => m.FasecoldaNotFoundComponent,
      ),
  },
  {
    path: 'fin-de-flujo/cumulo',
    canActivate: [terminalFlowGuard],
    loadComponent: () =>
      import('./pages/terminal-flows/accumulation/accumulation.component').then(
        (m) => m.AccumulationComponent,
      ),
  },
  {
    path: 'fin-de-flujo/menor-de-edad',
    canActivate: [terminalFlowGuard],
    loadComponent: () =>
      import('./pages/terminal-flows/underage-payer/underage-payer.component').then(
        (m) => m.UnderagePayerComponent,
      ),
  },
  {
    path: 'fin-de-flujo/riesgos-consultables',
    canActivate: [terminalFlowGuard],
    loadComponent: () =>
      import('./pages/terminal-flows/consultable-risks/consultable-risks.component').then(
        (m) => m.ConsultableRisksComponent,
      ),
  },
  {
    path: 'fin-de-flujo/inactividad',
    loadComponent: () =>
      import('./pages/terminal-flows/inactivity/inactivity.component').then(
        (m) => m.InactivityComponent,
      ),
  },
  {
    // Salvamento no asegurable (PoliticaSura/PoliticaOtraCompania): el título viaja por
    // Router.navigate(..., { state }), nunca por query param.
    path: 'fin-de-flujo/evaluacion-historial-externo',
    canActivate: [terminalFlowGuard],
    loadComponent: () =>
      import(
        './pages/terminal-flows/salvamento-sura-no-asegurable/salvamento-sura-no-asegurable.component'
      ).then((m) => m.SalvamentoSuraNoAsegurableComponent),
  },
  {
    path: 'fin-de-flujo/poliza-activa',
    canActivate: [terminalFlowGuard],
    loadComponent: () =>
      import('./pages/terminal-flows/policy-active/policy-active.component').then(
        (m) => m.PolicyActiveComponent,
      ),
  },
  {
    // Comodín: cualquier ruta que no exista en la app es, para el usuario, un 404.
    path: '**',
    loadComponent: () =>
      import('./pages/terminal-flows/not-found-error/not-found-error.component').then(
        (m) => m.NotFoundErrorComponent,
      ),
  },
];
